module.exports = __webpack_public_path__ + "media/images/arrow-icon-8fedfdd0afd7f0b3c290fdccfc33c725.svg";